import Link from 'next/link'
import { useContext, useEffect } from 'react'
import { Navigation } from '@/components/NavigationContext'
import { array_chunks } from '@/helpers/array'
import Head from 'next/head'

const About = ({ content, navigation }) => {
    const { setNavigationItems } = useContext(Navigation)

    useEffect(() => {
        if (navigation) {
            setNavigationItems(navigation)
        }
    }, [navigation])

    const getAge = () => {
        const dob = new Date("01/27/2001")

        //calculate month difference from current date in time
        const month_diff = Date.now() - dob.getTime()
    
        //convert the calculated difference in date format
        const age_dt = new Date(month_diff)
    
        //extract year from date
        const year = age_dt.getUTCFullYear()
    
        //now calculate the age of the user
        return Math.abs(year - 1970)
    }

    return (
        <>
            <Head>
                <title>About | Studio Rinsma</title>
                <meta name="description" content={content.imageTextBlock.content.replace('%age%', getAge()).split('</p>')[0].replace( /(<([^>]+)>)/ig, '')} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <div className="page-about">
                <header>
                    <span className="heading-js-wrapper">
                        <span className="about-title" style={{animationDelay: '.2s'}} dangerouslySetInnerHTML={{__html: content.header.title}} />
                    </span>
                </header>

                <section className="half-fold">
                    <div className="global-wrapper">
                        <div className="half-fold-inner">
                            <div className="image-wrapper">
                                <img src={content.imageTextBlock.image} alt={content.imageTextBlock.imageAlt} />
                            </div>

                            <div className="text-wrapper">
                                <h1>{content.imageTextBlock.title}</h1>
                                <div dangerouslySetInnerHTML={{__html: content.imageTextBlock.content.replace('%age%', getAge())}} />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="experience-wrapper">
                    <div className="global-wrapper">
                        <div className="experience-inner">
                            <h2>{content.experienceBlock.title}</h2>

                            <div className="bullet-wrapper">
                                {array_chunks(content.experienceBlock.items).map((group, index) => (
                                    <ul key={index}>
                                        {group.map((item, index) => (
                                            <li key={index}>{item.title}</li>
                                        ))}
                                    </ul>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="gallery-wrapper">
                    {content.smallImageGallery.images.map((image, index) => (
                        <img key={index} src={image.url} alt={image.title} />
                    ))}
                </section>

                <section className="cta-wrapper">
                    <div className="global-wrapper">
                        <Link href={`/${content.cta.link}`} className="cta-inner">
                            <div className="cta-content">
                                <span className="cta-title">{content.cta.title}</span>
                                <span className="cta-subtext">{content.cta.subtext}</span>
                            </div>

                            <div className="cta-link-wrapper">
                                <i className="fas fa-arrow-right-long" />
                            </div>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    )
}

export default About

export async function getServerSideProps() {
    const res = await fetch(`${process.env.API_URL}/page/about.json`)
    const content = await res.json()

    const navigationRes = await fetch(`${process.env.API_URL}/api/globals.json`)
    const navigation = await navigationRes.json()

    return {
        props: {
            content,
            navigation,
        }
    }
}